import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { prototypeRoutes } from './prototype'
import { defaultRoutes } from './default'
import { setCurrentRouteContext } from '@/http/axios-interceptor'
import roleAccessManager from '@/utils/role-access-manager'

let routes = defaultRoutes
if (process.env.NODE_ENV == 'prototype') {
  routes = prototypeRoutes
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes
})

// Global route guard untuk set context dan check access
router.beforeEach((to, from, next) => {
  // Set current route path ke context untuk dikirim ke backend
  // const path = to.path.split('/').slice(0, 2).join('/') || '/'
  const path = to.path || localStorage.getItem('default_dashboard_path') || '/'  
  setCurrentRouteContext(path, 'read')
  
  // TODO: Implement role access check untuk path tertentu
  // Untuk sekarang hanya log, nanti akan implement real check
  
  next()
})

export default router
